import { IonCol, IonContent, IonGrid, IonPage, IonRow } from "@ionic/react";
import { closeOutline } from "ionicons/icons";
import React, { useState } from "react";
import { withRouter } from "react-router";

import {
  HistorialTrabajoFiltrosProps,
  PuntoServicio,
} from "src/utils/interfaces";

import { adjuntarComoQueryParam as adjuntar } from "src/utils/comunicacionAPI";
import { opcionAPuntoServicio } from "src/utils/especificos";
import { dateAFormatoGlobal } from "src/utils/fechas";

import { Button } from "@material-ui/core";
import Header from "src/components/Header";
import Autocomplete from "src/components/Autocomplete";
import DatePicker from "src/components/DatePicker";
import Checkbox from "src/components/CheckBox";

const HistorialDeTrabajoFiltros: React.FC<HistorialTrabajoFiltrosProps> = (
  props: HistorialTrabajoFiltrosProps
) => {
  const [puntoDeServicio, setPuntoDeServicio] = useState<
    PuntoServicio | undefined
  >(props.filtros.puntoDeServicio);
  const [fechaInicio, setFechaInicio] = useState<Date | undefined>(
    props.filtros.fechaInicio
  );
  const [fechaFin, setFechaFin] = useState<Date | undefined>(
    props.filtros.fechaFin
  );
  const [soloProcesadas, setSoloProcesadas] = useState<boolean | undefined>(
    props.filtros.soloHorasProcesadas
  );
  const [soloSinProcesar, setSoloSinProcesar] = useState<boolean | undefined>(
    props.filtros.soloHorasSinProcesar
  );

  const handleClickFiltrar = () => {
    const filtros = {
      puntoDeServicio: puntoDeServicio,
      fechaInicio: fechaInicio,
      fechaFin: fechaFin,
      soloHorasProcesadas: soloProcesadas,
      soloHorasSinProcesar: soloSinProcesar,
    };

    const inicio = fechaInicio ? dateAFormatoGlobal(fechaInicio) : undefined;
    const fin = fechaFin ? dateAFormatoGlobal(fechaFin) : undefined;

    const procesadas = soloProcesadas ? 1 : "";
    const sinProcesar = soloSinProcesar ? 1 : "";

    let params = "";
    params = adjuntar(params, "nombre_ps", puntoDeServicio?.nombre);
    params = adjuntar(params, "codigo_ps", puntoDeServicio?.codigo);
    params = adjuntar(params, "fecha_desde", inicio);
    params = adjuntar(params, "fecha_hasta", fin);
    params = adjuntar(params, "solo_procesadas", procesadas);
    params = adjuntar(params, "solo_sin_procesar", sinProcesar);

    props.handleFiltrosChange(filtros);
    props.history.push(`/historial-de-trabajo${params}`);
  };

  const limpiarFiltros = () => {
    setPuntoDeServicio(undefined);
    setFechaInicio(undefined);
    setFechaFin(undefined);
    setSoloProcesadas(undefined);
    setSoloSinProcesar(undefined);

    props.handleFiltrosChange({
      puntoDeServicio: undefined,
      fechaInicio: undefined,
      fechaFin: undefined,
      soloHorasProcesadas: undefined,
      soloHorasSinProcesar: undefined,
    });

    props.history.push("/historial-de-trabajo");
  };

  const opcion = puntoDeServicio
    ? {
        id: puntoDeServicio.codigo,
        nombre: puntoDeServicio.nombre,
      }
    : null;

  const botonCerrar = {
    icono: closeOutline,
    action: () => props.history.goBack(),
  };

  const botonDerecho = {
    src: "assets/icon/clear-filter.svg",
    action: limpiarFiltros,
  };

  return (
    <IonPage>
      <Header
        titulo="Filtrar Historial"
        botonIzq={botonCerrar}
        botonesDerecha={[botonDerecho]}
      />

      <IonContent>
        <div className="container">
          <form
            id="filter-form"
            className="d-flex flex-column align-items-center"
          >
            <Autocomplete
              label="Punto de Servicio"
              className="mt-3"
              value={opcion}
              setValue={(opcion) =>
                setPuntoDeServicio(opcionAPuntoServicio(opcion))
              }
            />

            <IonGrid className="two-columns">
              <IonRow>
                <IonCol>
                  <DatePicker
                    className="half"
                    value={fechaInicio}
                    setValue={setFechaInicio}
                    placeholder="Fecha inicial"
                  />
                </IonCol>

                <IonCol>
                  <DatePicker
                    className="half"
                    value={fechaFin}
                    setValue={setFechaFin}
                    placeholder="Fecha final"
                  />
                </IonCol>
              </IonRow>
            </IonGrid>

            <Checkbox
              className="input-width mb-1"
              label="Horas Procesadas"
              checked={soloProcesadas}
              setChecked={setSoloProcesadas}
            />

            <Checkbox
              className="input-width mb-3"
              label="Horas sin Procesar"
              checked={soloSinProcesar}
              setChecked={setSoloSinProcesar}
            />

            <Button
              className="button"
              variant="contained"
              color="primary"
              onClick={handleClickFiltrar}
            >
              FILTRAR
            </Button>
          </form>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default withRouter(HistorialDeTrabajoFiltros);
